module.exports = __webpack_public_path__ + "img/logo-light.50ab6f6d.png";